import { createFileRoute } from '@tanstack/react-router';

import { CodebaseTabFlagGate } from '@/components/CodebaseView/CodebaseTabFlagGate';
import { FEATURE_FLAGS } from '@/constants/featureFlags';

// The Docs tab is gated behind the org-level DOCS_UI flag (default-off → hidden).
// With the flag off, every page under it lands on the Settings tab.
export const Route = createFileRoute('/$organizationName/cb/$codebaseId/tree')({
  component: GatedCodebaseDocsLayout,
});

function GatedCodebaseDocsLayout() {
  return <CodebaseTabFlagGate flag={FEATURE_FLAGS.DOCS_UI} />;
}
